import Lenis from 'lenis'

function lenisScroll () {
  const lenis = new Lenis({
    smoothWheel: true,
    wheelMultiplier: 1,    // Reducido de 1 para un scroll más suave
    duration: 1.6,           // Aumentado de 1 para una animación más prolongada
    easing: (t) => Math.min(1, 1.001 - Math.pow(2, -10 * t * 1.2)), // Ajustado para mayor suavidad
    lerp: 0.08,              // Factor de interpolación lineal (nuevo parámetro)
    smoothTouch: true,       // Activado para dispositivos táctiles
    touchMultiplier: 4,    // Reducido de 2 para más suavidad
    infinite: false          // Infinite scrolling
  })

  // Store the lenis instance on the window object for use in other modules
  window.lenis = lenis // Cambiado de lenisInstance a lenis para coincidir con el código en snapScroll

  const smoothLinks = document.querySelectorAll('.anchor')

  smoothLinks.forEach(link => {
    link.addEventListener('click', (e) => {
      e.preventDefault()
      const anchor = link.getAttribute('href')
      if (!anchor) return;

      lenis.scrollTo(anchor, {
        duration: 2, // Puedes ajustar la duración según tus necesidades
        easing: (t) => 1 - Math.pow(1 - t, 6) // Ejemplo de una función de easing personalizada
      })
    })
  })

  /* Go To */
  function goTo(){

    function getUrlParams(name) {
      name = name.replace(/[\[]/, '\\[').replace(/[\]]/, '\\]');
      var regex = new RegExp('[\\?&]' + name + '=([^&#]*)');
      var results = regex.exec(location.search);
      return results === null ? '' : decodeURIComponent(results[1].replace(/\+/g, ' '));
    }

    const go = getUrlParams('go');
  
    if( go ){
      setTimeout(
        () => {
          window.lenis.scrollTo('#'+go, {
            duration: 2,
            easing: (t) => 1 - Math.pow(1 - t, 6)
          });
        },
        1500
      );
    }
  
  }

  goTo();

  // lenis.on('scroll', (e) => {
  //   console.log(e)
  // })

  function raf(time) {
    lenis.raf(time)
    requestAnimationFrame(raf)
  }

  requestAnimationFrame(raf)
}

export default lenisScroll
